/**
 * @fileoverview Loading component for Click&Pledge interface.
 * Displays loading animations and handles out-of-context scenarios.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Loading component that displays a loading animation or error message.
 * Shows different content based on whether the app is called within an event context.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.appoutofcontext - Whether app is called outside of event context
 * @returns {ReactElement} The loading component with animation or error message
 */
const Loading = props => {
    const { t } = useTranslation();

    return (
        <div className = 'loader-section'>
            {props.appoutofcontext
                ? <h3>{t('clickandpledge.appCanOnlyBeCalledWithinEvent')}</h3>
                : <h3>{t('clickandpledge.loading')}</h3>
            }

            {/* <canvas id="my-canvas" style={{width:'100%',height:'100%'}}></canvas> */}
            {!props.appoutofcontext && (
                <div className = 'loader-container'>
                    <div className = 'lds-ellipsis'>
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
            )}

        </div>
    );
};

export default Loading;
